import type { CSSProperties } from "react";
import "./press.css";

/**
 * The class every tappable v2 atom carries: `transform: scale(.98)` +
 * `opacity: .8` over 120ms on `:active` (see `press.css`).
 *
 * Exported as a constant so a screen composing its own tappable element gets
 * the same press without restating the rule, and so tests can assert it.
 */
export const PRESS_CLASS = "d-v2-press";

/**
 * The class a `Row` carries: a 4% `--d-fg` wash on hover, for desktop only.
 * Never combined with `PRESS_CLASS` — the handoff gives rows a hover, not a
 * press.
 */
export const ROW_CLASS = "d-v2-row";

/** `PRESS_CLASS` merged with whatever the consumer passed. */
export function pressClass(className?: string): string {
  return className ? `${PRESS_CLASS} ${className}` : PRESS_CLASS;
}

/**
 * The reset a `<button>` needs before it can look like the handoff's `<div
 * onClick>`. The prototypes use divs; we use real buttons so the atoms are
 * focusable, keyboard-operable and named in the a11y tree — the styling is
 * the handoff's, the element is not.
 */
export const BUTTON_RESET: CSSProperties = {
  appearance: "none",
  background: "none",
  border: "none",
  margin: 0,
  padding: 0,
};
